export default {
    dealers_tab_id: 'Id',
    dealers_tab_name: 'Nombre',
    dealers_tab_email: 'Correo',
    dealers_tab_username: 'Nombre de usuario',
    dealers_tab_companies: 'Compañias',
    dealers_tab_dealers: 'Distribuidores',
    dealers_tab_master_company_name: 'Compañía Maestra',
    dealers_tab_apply: 'Aplicar',
    dealers_tab_tags: 'Etiquetas',
    dealers_tab_active_dealers_only: 'Sólo cuentas activas',
    dealers_tab_yes: 'Si',
    dealers_tab_no: 'No',
    dealers_tab_authenticate_cloud: 'Iniciar sesión como cliente',
    dealers_tab_re_sync_backend_information: 'Re-sincronización de la información del backend',
    dealers_tab_devices: 'Dispositivos',
    dealers_tab_package: 'Paquete',
    dealers_tab_crm: 'Id. de Salesforce',
    dealers_tab_add_dealer: 'Agregar distribuidor',
    dealers_tab_edit: 'Editar',
    dealers_tab_remove_filters: 'Eliminar los filtros',
    dealers_tab_account_details: 'Detalles de la cuenta',
    dealers_tab_import_from_p4: 'Importar desde P4',
    dealers_tab_reprocess_odo_hours: 'Reprocesar Odo/Hrs',
    dealers_tab_new_status: 'Nuevo Estado',
    dealers_tab_at: 'el',
    dealers_tab_next_scheduled_action: 'Próxima acción programada',
    dealers_tab_on: 'en',
    dealers_tab_brand: 'Marca',
};